import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { createPermissionDocument, fetchPermissionDocuments, deletePermissionDocument } from '../../../../store/startup/documents/documentSlice';
import {
    Box,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Modal,
    Paper,
    Grid2
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from '@mui/material/Button';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { Add } from '@mui/icons-material';
import SingleFileUpload from '../../../fileUpload/FileUpload';
import { getFileLink } from '../../../../utils/getFileLink';

const PermissionDocument = () => {
    const [open, setOpen] = useState(false);
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [documentFilePath, setDocumentFilePath] = useState('');
    const [errors, setErrors] = useState({
        subject: false,
        description: false,
        documentFilePath: false
    });
    const dispatch = useDispatch();
    const { startupId } = useParams();

    const { permissionDocuments, loading } = useSelector(state => state.documents);

    useEffect(() => {
        dispatch(fetchPermissionDocuments(startupId));
    }, [dispatch, startupId]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSubject('');
        setDescription('');
        setDocumentFilePath('');
    };

    const handleSave = async () => {
        setErrors({
            subject: false,
            description: false,
            documentFilePath: false
        });

        const newErrors = {
            subject: !subject.trim(),
            description: !description.trim(),
            documentFilePath: !documentFilePath
        };

        if (Object.values(newErrors).some(error => error)) {
            setErrors(newErrors);
            return;
        }

        const documentData = {
            startupId,
            subject,
            description,
            documentFilePath: documentFilePath || ""
        };

        try {
            await dispatch(createPermissionDocument(documentData)).unwrap();
            await dispatch(fetchPermissionDocuments(startupId));
            handleClose();
        } catch (error) {
            console.error('Failed to create permission document:', error);
        }
    };

    const handleDelete = async (permissionsApprovalId) => {
        try {
            await dispatch(deletePermissionDocument(permissionsApprovalId)).unwrap();
        } catch (error) {
            console.error('Failed to delete permission document:', error);
        }
    };

    const handleDocumentUpload = (filePath) => {
        setDocumentFilePath(filePath);
    }

    return (
        <div>
            <Box sx={{ display: 'flex', width: '100%' }}>
                <Box sx={{ flexGrow: 1, width: '80%' }}>
                    <Typography variant="h5" sx={{ mb: 2 }}>
                        İzin ve Onaylar
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'right', width: '20%', height: '1%' }}>
                    <Button variant="outlined" size="small" color="primary" startIcon={<Add />} onClick={handleOpen}>
                        Yeni Ekle
                    </Button>
                </Box>
                <Divider sx={{ marginBottom: 3 }} />
            </Box>
            <Box>
                <TableContainer component={Paper} sx={{ marginBottom: 1 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Konu</TableCell>
                                <TableCell>Açıklama</TableCell>
                                <TableCell>Dosya</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {permissionDocuments.map((startupPermissionDocument, index) => (
                                <TableRow key={index}>
                                    <TableCell>{startupPermissionDocument.subject}</TableCell>
                                    <TableCell>{startupPermissionDocument.description}</TableCell>
                                    <TableCell>
                                        {startupPermissionDocument.documentFilePath !== "" ? (
                                            <a href={getFileLink(startupPermissionDocument.documentFilePath)} target="_blank" rel="noopener noreferrer">
                                                Döküman Linki
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button size='small' color="error" startIcon={<DeleteIcon />} onClick={() => handleDelete(startupPermissionDocument.permissionsApprovalId)}>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            {/* Modal */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 800,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 1,
                    }}
                >
                    <Typography id="modal-title" variant="h6" sx={{ mb: 2 }}>
                        Yeni Belge Ekle
                    </Typography>

                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 8 }}>
                            <TextField
                                label="Konu"
                                fullWidth
                                sx={{ marginBottom: 2 }}
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                error={errors.subject}
                                helperText={errors.subject ? "Konu boş bırakılamaz" : ""}
                            />
                            <TextField
                                label="Açıklama"
                                fullWidth
                                multiline
                                rows={4}
                                sx={{ marginBottom: 2 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                error={errors.description}
                                helperText={errors.description ? "Açıklama boş bırakılamaz" : ""}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 4 }}>
                            <Box sx={{ width: '%100', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90%' }} >
                                <SingleFileUpload onUploadComplete={handleDocumentUpload} existFilePath={documentFilePath} fileUploadPath={"startup"} />
                            </Box>
                            {errors.documentFilePath && (
                                <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                                    Lütfen bir dosya yükleyin
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant="outlined" color="error" onClick={handleClose}>
                            İptal
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            Kaydet
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default PermissionDocument;
